<template>
    <main class="page-shell narrow">
        <section class="text-center profile-heading">
            <span class="brand-kicker">Player profile</span>
            <h1 class="brand-title">Your stream stats.</h1>
            <p class="brand-subtitle">Account details and play history for your Sidestream setup.</p>
        </section>

        <ProfileDetails/>
    </main>
</template>

<script>
import ProfileDetails from '@/components/ProfileDetails.vue'

export default {
    name: 'Profile',
    components: {
        ProfileDetails
    }
}
</script>

<style scoped>
.profile-heading {
    margin-bottom: 1.5rem;
}
</style>
